import { trans } from '@/lib/calendesk-js-library/prototypes/trans'
import { SelectionOrderType } from '@/calendesk/models/SelectionOrderType'

export default () => [
  {
    text: trans('wb_selection_order_service_location_employee'),
    value: SelectionOrderType.SERVICE_LOCATION_EMPLOYEE
  },
  {
    text: trans('wb_selection_order_service_employee_location'),
    value: SelectionOrderType.SERVICE_EMPLOYEE_LOCATION
  },
  {
    text: trans('wb_selection_order_location_service_employee'),
    value: SelectionOrderType.LOCATION_SERVICE_EMPLOYEE
  },
  {
    text: trans('wb_selection_order_location_employee_service'),
    value: SelectionOrderType.LOCATION_EMPLOYEE_SERVICE
  },
  {
    text: trans('wb_selection_order_employee_service_location'),
    value: SelectionOrderType.EMPLOYEE_SERVICE_LOCATION
  },
  {
    text: trans('wb_selection_order_employee_location_service'),
    value: SelectionOrderType.EMPLOYEE_LOCATION_SERVICE
  }
]
